import { render, staticRenderFns } from "./Cominterface.vue?vue&type=template&id=228500a6&scoped=true&"
import script from "./Cominterface.vue?vue&type=script&lang=js&"
export * from "./Cominterface.vue?vue&type=script&lang=js&"
import style0 from "./Cominterface.vue?vue&type=style&index=0&id=228500a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228500a6",
  null
  
)

export default component.exports